import { X } from "lucide-react";
import { Link } from "react-router-dom";
import {
  FILTER_CHIP_MAX_VALUE,
  filterLabel,
  filtersFromSearch,
  isKnownDim,
  truncateMiddle,
  withoutFilter,
} from "../../web-analytics";

/**
 * Active filters as removable chips. Renders nothing when there are none.
 * Each × is a real link to the same page without that filter, so the back
 * button restores it. Ported from Sonar's FilterBar.
 */
export default function FilterBar({ search }: { search: URLSearchParams }) {
  const filters = filtersFromSearch(search);
  if (!filters.length) return null;
  return (
    <div className="wa-filters" role="group" aria-label="Active filters">
      {filters.map((f) => {
        const known = isKnownDim(f.dim);
        const full = known ? filterLabel(f) : `${f.dim}:${f.value}`;
        // An unknown dim matches nothing on the server; say so instead of looking like a real filter.
        const shown = known ? filterLabel({ ...f, value: truncateMiddle(f.value, FILTER_CHIP_MAX_VALUE) }) : "No such filter; nothing matches";
        return (
          <span key={f.dim} className={known ? "wa-chip" : "wa-chip wa-chip-bad"}>
            <span className="wa-chip-label" title={full}>{shown}</span>
            <Link to={{ search: withoutFilter(search, f.dim) }} className="wa-chip-remove" aria-label={`Remove filter: ${shown}`}>
              <X aria-hidden="true" />
            </Link>
          </span>
        );
      })}
      {filters.length >= 2 && (
        <Link to={{ search: withoutFilter(search, null) }} className="wa-clear">Clear all</Link>
      )}
    </div>
  );
}
